// extracted by mini-css-extract-plugin
module.exports = {"label":"EnumLabel_label__3qQIT","badge":"EnumLabel_badge__2E6EG"};